import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import FormField from '../../../components/FormField'
import { connectEditCourse, showDeleteCourseModalMethod } from '../actions'

class ConnectedCourseRow extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      edit: false,
      editCourse: {
        id: this.props.courseId,
        courseNum: this.props.coursenum,
        descr: this.props.descr,
        thumbnailUri: this.props.thumbnailUri,
        currentRev: this.props.revision,
      },
    }
  }

  handleCourseChange = event => {
    let {
      target: { name, value },
    } = event
    this.setState({
      editCourse: {
        ...this.state.editCourse,
        [name]: value,
      },
    })
  }

  editCourse = () => {
    this.setState(prevState => ({
      edit: !prevState.edit,
    }))
  }

  saveEditCourse = () => {
    this.props.editCourse(this.props.orgId, this.state.editCourse)
    this.editCourse()
  }

  deleteCourse = () => {
    this.props.showDeleteModal(this.state.editCourse.id)
  }

  render() {
    if (!this.state.edit) {
      return (
        <tr>
          <td>{this.props.coursenum}</td>
          <td>{this.props.descr}</td>
          <td>{this.props.thumbnailUri}</td>
          <td>{this.props.revision}</td>
          <td>
            <button onClick={this.editCourse} className="btn btn-primary">
              Edit
            </button>
            <button onClick={this.deleteCourse} className="btn btn-danger">
              Delete
            </button>
          </td>
        </tr>
      )
    } else {
      return (
        <tr>
          <td>{this.props.coursenum}</td>
          <td>
            <FormField
              name="descr"
              label={null}
              value={this.state.editCourse.descr}
              handler={this.handleCourseChange}
              type="text"
            />
          </td>
          <td>
            <FormField
              name="thumbnailUri"
              label={null}
              value={this.state.editCourse.thumbnailUri}
              handler={this.handleCourseChange}
              type="text"
            />
          </td>
          <td>{this.props.revision}</td>
          <td>
            <button onClick={this.saveEditCourse} className="btn btn-primary">
              Save
            </button>
          </td>
        </tr>
      )
    }
  }
}

ConnectedCourseRow.propTypes = {
  courseId: PropTypes.string,
  coursenum: PropTypes.string,
  descr: PropTypes.string,
  thumbnailUri: PropTypes.string,
  revision: PropTypes.string,
  orgId: PropTypes.string,
  editCourse: PropTypes.func,
  showDeleteModal: PropTypes.func,
}

const mapStateToProps = state => {
  return {
    orgId: state.selectedOrgId,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    editCourse: (selectedOrgId, courseData) => {
      dispatch(connectEditCourse(selectedOrgId, courseData))
    },
    showDeleteModal: deleteCourseId => {
      dispatch(showDeleteCourseModalMethod(deleteCourseId))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedCourseRow)
